(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-announcement-signup]');
    if (!link) return;
    const creative = window.innerWidth >= 760 ? link.dataset.attentiveDesktop : link.dataset.attentiveMobile;
    if (!creative || typeof window.__attentive?.trigger !== 'function') return;
    try {
      window.__attentive.trigger(null, null, null, creative);
      event.preventDefault();
    } catch (error) {
      window.location.hash = 'footer-signup';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunice-help-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches('[data-help-search]')) return;
    const hub = input.closest('[data-help-hub]');
    if (!hub) return;
    const query = input.value.trim().toLocaleLowerCase();
    let matches = 0;
    hub.querySelectorAll('[data-help-topic]').forEach((topic) => {
      const text = `${topic.textContent} ${topic.dataset.keywords || ''}`.toLocaleLowerCase();
      const visible = query === '' || text.includes(query);
      topic.hidden = !visible;
      if (visible) matches += 1;
    });
    const empty = hub.querySelector('[data-help-empty]');
    const status = hub.querySelector('[data-help-status]');
    if (empty) empty.hidden = matches !== 0;
    if (status) status.textContent = matches === 0 ? empty.textContent.trim() : '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunice-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sunice-hero-carousel')) {
    customElements.define('sunice-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
        this.visible = true;
        this.toggle = this.querySelector('[data-toggle]');
        if (this.slides.length < 2) return;
        this.querySelector('.sunice-hero__controls').hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.paused = !this.paused;
            this.sync();
          } else if (button.hasAttribute('data-next')) this.go(this.index + 1);
          else if (button.hasAttribute('data-previous')) this.go(this.index - 1);
          else if (button.hasAttribute('data-dot')) this.go(Number(button.dataset.dot));
        }, { signal });
        this.addEventListener('focusin', (event) => {
          if (!this.contains(event.relatedTarget) && event.target.matches(':focus-visible')) {
            this.paused = true;
            this.sync();
          }
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' || event.target.closest('a, button')) return;
          this.touch = { x: event.clientX, y: event.clientY };
        }, { signal });
        this.addEventListener('pointerup', (event) => {
          if (!this.touch) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1));
        }, { signal });
        this.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => {
          if (this.reducedMotion.matches) this.paused = true;
          this.sync();
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, { signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        this.go(0);
      }
      go(index) {
        const previousSlide = this.slides[this.index];
        this.index = (index + this.slides.length) % this.slides.length;
        if (previousSlide !== this.slides[this.index] && previousSlide.contains(document.activeElement)) this.dots[this.index].focus();
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          if (active) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          if (active) this.dots[i].setAttribute('aria-current', 'true');
          else this.dots[i].removeAttribute('aria-current');
        });
        this.sync();
      }
      sync() {
        this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.querySelector('.sunice-hero__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 6000));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
